import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Modal from '../Components/Modal';
import { hideModal } from '../Actions/Modal.action';

class ModalContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
    }

    render() {
        return <Fragment>
            {this.props.modal && this.props.modal.text && 
                <Modal text={this.props.modal.text} btntext={this.props.modal.btntext} hide={this.props.hideModal} />
            }
        </Fragment>
    }
}

const mapStateToProps = state => {
    return {
        modal: state.modal,
    }
}

const mapDispatchToProps = {
    hideModal
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);